export { default } from "./EntryDialog";
